module.exports = __webpack_public_path__ + "img/comedy_logo.bd34cf99.svg";